import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import { DashboardComponent } from '../dashboard.component';
import { PartnersComponent } from '../partners/partners.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {PageEvent} from '@angular/material/paginator';
import { MatRadioChange } from '@angular/material/radio';
import {MatSnackBar} from '@angular/material/snack-bar';

import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';

import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY / MM / DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-newpurchasecontract',
  templateUrl: './newpurchasecontract.component.html',
  styleUrls: ['./newpurchasecontract.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})

export class NewpurchasecontractComponent implements OnInit {

  purchasecontractURLID:any;

  DocumentDate = new FormControl(moment());
  PaymentDueDate =  new FormControl(moment());
  StockEntryDate =  new FormControl(moment());

  loadingEditProduct = false;
  showAddNewPartnerPopUp = false;
  showEditPartnerPopUp = false;

  //new partner members
  newPartnerCountry:any;
  newPartnerBank:any;
  masterData:any;
  DocumentBodyLoading:boolean;

  newPartner:any;
  partner:any;
  currentPartner:any;
  currency:any;
  showAccountingSeriesError:boolean;
  SuggestProducts:boolean;

  searchTerm:string;

  countryID:number;

  resultsLength = 0;
  pageSize = 999999;

  Partners:any[];

  Currencies:any[];
  DocTypes:any[];
  DecimalPrecisions:any[];
  DiscountTypes:any[];
  AccountingSeries:any[];
  Administrations:any[];
  MeasuringUnits:any[];
  VATRates:any[];
  ProductGeneralTypes:any[];
  TaxDivisionTypes:any[];
  PurchaseContractsMasterData:any;

  NewProductPriceContainsVAT:boolean;
  IsStorno:boolean;

  PurchaseContractPrecision:any;
  IsValidNewProduct:boolean;

  Products:any[];

  ProductsSearchResults:any[];
  ProductsSearchResultsCOUNT:any;

  ProductsSearchResultsPop:any[];
  ProductsSearchResultsCOUNTPop:any;

  loadingSearchProducts:boolean;

  NewProduct:any;
  CurrentProduct:any;
  CurrentIndexProduct:number;
  CurrentPurchaseContract: {[k: string]: any} = {};

  SavedPurchaseContract:boolean;
  showPurchaseContractVisualizer:boolean;

  showSearch:boolean;
  showSearchCurrent:boolean;
  HasInitialPayments:boolean;
  InitialPayments:any[];
  InitialPaymentsRemainingValue:any;
  ShowDocumentError:boolean;

  searchPartnerUpdate = new Subject<string>();

  constructor(public parent: DashboardComponent, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private route: ActivatedRoute, private router:Router) { 

    translate.addLangs(['en', 'ro']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro/) ? browserLang : 'en');

     // Debounce search.
     this.searchPartnerUpdate.pipe(
      debounceTime(400),
      distinctUntilChanged())
      .subscribe(value => {
        this.GetPartnersFiltered(value, this.countryID, true);
      });
  }

  ngOnInit(): void {

    this.SavedPurchaseContract = false;
    this.getParamValues();
    this.Products = new Array();
    this.countryID = null;
    this.masterData = this.parent.masterData;
    this.initializeAddPartnerForm();
    this.GetPurchaseContractsMasterData();
    
    this.IsValidNewProduct = false;
    this.showProductDiscountContainer = false;
    this.ProductsSearchResultsCOUNT = 0;
    this.showSearch = true;
    this.showSearchCurrent = true;
    this.ValidDocument = false;

    this.parent.PreventBrowserClose(true);

    if(this.purchasecontractURLID != undefined && this.purchasecontractURLID != null){
      this.GetPurchaseContract(this.purchasecontractURLID, false);
    }
  }

  showhideSearches(isFromPop:boolean){
    
    if(isFromPop){
      if(this.ProductsSearchResultsCOUNTPop > 0){
        this.showSearchCurrent = !this.showSearchCurrent;
      }
      else{
        this.showSearchCurrent = true;
      }
    }
    else{
      if(this.ProductsSearchResultsCOUNT > 0){
        this.showSearch = !this.showSearch;
      }
      else{
        this.showSearch = true;
      }
    }
  }

  GetPurchaseContract(id:string, IncludeTaxDistributionsInPrice:boolean){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ID:id,
      WithInfo:true,
      IsNewStorno:this.IsStorno,
      IncludeTaxDistributionsInPrice:IncludeTaxDistributionsInPrice
    };

    this.loadingEditProduct = true;

    this.service.GetPurchaseContract(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar", 30000);
        this.ShowDocumentError = true;
      }
      else if(response["Status"] == 1){
        this.FillPurchaseContractInfo(response["PurchaseContract"]);

        if(IncludeTaxDistributionsInPrice){
          this.CurrentPurchaseContract = response["PurchaseContract"];
          this.CurrentPurchaseContract.Products = this.CurrentPurchaseContract.Products.filter(x => x.ProductPurchaseContractInfo.GeneralType.IsTaxConsumed != true);
        }
      }
   
      this.TestDocumentValidity();
      this.loadingEditProduct = false;
    });
  }

  FillPurchaseContractInfo(purchasecontract:any){

    this.partner = {};
    this.partner = purchasecontract.Supplier;
    
    this.CurrentPurchaseContract = {};
    this.CurrentPurchaseContract.ID = purchasecontract.ID;
    this.CurrentPurchaseContract.DocType = purchasecontract.DocType;
    this.CurrentPurchaseContract.AccountingNumber = purchasecontract.AccountingNumber;
    this.CurrentPurchaseContract.Company = purchasecontract.Company;

    this.CurrentPurchaseContract.DocumentNumber = purchasecontract.DocumentNumber;

    this.CurrentPurchaseContract.DocumentDate = purchasecontract.DocumentDate;
    this.CurrentPurchaseContract.PaymentDueDate = purchasecontract.PaymentDueDate;
    this.CurrentPurchaseContract.StockEntryDate = purchasecontract.StockEntryDate;

    this.DocumentDate = new FormControl(moment(this.CurrentPurchaseContract.DocumentDate));
    this.PaymentDueDate = new FormControl(moment(this.CurrentPurchaseContract.PaymentDueDate));
    this.StockEntryDate = new FormControl(moment(this.CurrentPurchaseContract.StockEntryDate));

    this.currency = purchasecontract.Currency;

    if(purchasecontract.Products.length > 0){
      this.PurchaseContractPrecision = purchasecontract.Products[0].ProductPurchaseContractInfo.DecimalPrecision;
    }

    this.Products = purchasecontract.Products;

    this.CurrentPurchaseContract.Details = {};
    this.CurrentPurchaseContract.Details.ID = purchasecontract.Details.ID;
    this.CurrentPurchaseContract.Details.Observations = purchasecontract.Details.Observations;
    this.CurrentPurchaseContract.Details.InternalCommentary = purchasecontract.Details.InternalCommentary;
    this.CurrentPurchaseContract.Details.PurchaseContractCommittee = purchasecontract.Details.PurchaseContractCommittee;
    this.CurrentPurchaseContract.Details.Delegate = purchasecontract.Details.Delegate;
    this.CurrentPurchaseContract.Details.Auto = purchasecontract.Details.Auto;

    this.CurrentPurchaseContract.Total = {};
    this.CurrentPurchaseContract.Total = purchasecontract.Total;

    this.CurrentPurchaseContract.EventRegisterUI = purchasecontract.EventRegisterUI;

    this.CurrentPurchaseContract.DocumentStatus = purchasecontract.DocumentStatus;
    this.CurrentPurchaseContract.IsStorno = purchasecontract.IsStorno;
    this.CurrentPurchaseContract.Products = purchasecontract.Products;
    this.CurrentPurchaseContract.FilePath = purchasecontract.FilePath;
    this.IsStorno = purchasecontract.IsStorno;
  }
  
  getParamValues() {
    this.route.queryParams.subscribe(params => {      
        this.purchasecontractURLID = params['id'];
        
        if(params['HasInitialPayments'] == undefined){
          this.HasInitialPayments = false;
        }
        else{
          this.HasInitialPayments = JSON.parse(params['HasInitialPayments']);

          if(this.HasInitialPayments){
            this.FillInitialPayments();
          }
        }

        if(params['IsStorno'] == undefined){
          this.IsStorno = false;
        }
        else{
          this.IsStorno = JSON.parse(params['IsStorno']);
        }
    });
  }

  FillInitialPayments(){
    if(localStorage.getItem("SelectedPayments") != undefined){
      this.InitialPayments = JSON.parse(localStorage.getItem("SelectedPayments"));
    }
  }

  GetRemainingUIPCValueFromTotal(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Payments:this.InitialPayments,
      DecimalPrecision:this.PurchaseContractPrecision,
      Total:this.CurrentPurchaseContract.Total,
      TargetCurrency:this.currency
    };

    if(this.HasInitialPayments == true){
      this.service.GetRemainingUIPCValueFromTotal(request).subscribe(response => {
   
        if(response["Status"] == 1){
         this.InitialPaymentsRemainingValue = response["RemainingValue"];
       }
    
     });
    }
  }

  InitializeNewPurchaseContract(){
    
    this.CurrentPurchaseContract.AccountingNumber = {};
    this.CurrentPurchaseContract.AccountingNumber.ID = null;
    this.CurrentPurchaseContract.AccountingNumber.AccountingSeries = {};
    this.CurrentPurchaseContract.AccountingNumber.AccountingSeries = this.AccountingSeries[0];
    this.CurrentPurchaseContract.Supplier = {};
    this.CurrentPurchaseContract.Company = {};
    this.CurrentPurchaseContract.Company = this.parent.Company;
    this.CurrentPurchaseContract.DocType = {};
    this.CurrentPurchaseContract.DocType = this.DocTypes[0];
    this.CurrentPurchaseContract.DocumentNumber = "";
    this.CurrentPurchaseContract.DocumentDate = {};
    this.CurrentPurchaseContract.PaymentDueDate = {};
    this.CurrentPurchaseContract.StockEntryDate = {};
    this.CurrentPurchaseContract.Currency = {};
    this.CurrentPurchaseContract.Products = [];
    this.CurrentPurchaseContract.Products = this.Products;
    this.CurrentPurchaseContract.Details = {};
    this.CurrentPurchaseContract.ID = null;

    this.CurrentPurchaseContract.DocumentStatus = {};
    this.CurrentPurchaseContract.DocumentStatus.ID = 1;

    this.CurrentPurchaseContract.IsStorno = this.IsStorno;

    this.CurrentPurchaseContract.Total = {};
    this.CurrentPurchaseContract.Total.Discount = {};
    this.GetRemainingUIPCValueFromTotal();
  }

  InitializeNewProduct(){

    var Administration = null;

    if(this.NewProduct?.ProductPurchaseContractInfo?.Administration != null){
      Administration = JSON.parse(JSON.stringify(this.NewProduct?.ProductPurchaseContractInfo?.Administration));
    }
    else{
      Administration = JSON.parse(JSON.stringify(this.Administrations[0]));
    }

    this.NewProduct = {
      ID:null,
      GeneralType:this.ProductGeneralTypes[0],
      ProductPurchaseContractInfo:{
        Administration:Administration,
        Name:"",
        Code:"",
        MeasuringUnit:this.MeasuringUnits[0],
        Quantity:1,
        DocQuantity:1,
        Price:{
          VAT:this.VATRates[0]
        },
        Total:null,
        TotalVATValue:null,
      },
    };

    this.IsValidNewProduct = false;
  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
}

  compareFirst(c1: any, c2: any): boolean {
  return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
}


  initializeAddPartnerForm(){
    this.newPartner = new FormGroup({

      VAT:new FormControl(''),
      UPN:new FormControl(''),
      Name:new FormControl('', [Validators.required]),
      COCRegNumber:new FormControl(''),
  
      TaxPayer:new FormControl(''),
  
      Country:new FormControl(''),
      StateProvince:new FormControl(''),
      City:new FormControl(''),
      AddressLine:new FormControl('', [Validators.required]),
      ZipCode:new FormControl(''),

      Bank:new FormControl(''),
      BankAccount:new FormControl(''),
  
      Email: new FormControl('', [Validators.email]),
      ContactName:new FormControl(''),
      Phone:new FormControl(''),
    });
  }

  initializePartnerFormFromObject(partner:any){

    this.currentPartner = new FormGroup({

      VAT:new FormControl(partner.VAT),
      UPN:new FormControl(partner.UPN),
      Name:new FormControl(partner.Name, [Validators.required]),
      COCRegNumber:new FormControl(partner.COCRegNumber),
  
      TaxPayer:new FormControl(partner.TaxPayer),
  
      Country:new FormControl(partner.BillingAddress.Country),
      StateProvince:new FormControl(partner.BillingAddress.StateProvince, [Validators.required]),
      City:new FormControl(partner.BillingAddress.City, [Validators.required]),
      AddressLine:new FormControl(partner.BillingAddress.AddressLine, [Validators.required]),
      ZipCode:new FormControl(partner.BillingAddress.ZipCode),

      Bank:new FormControl(partner.Bank),
      BankAccount:new FormControl(partner.Bank.BankAccount),
  
      Email: new FormControl(partner.ContactInfo.Email, [Validators.email]),
      ContactName:new FormControl(partner.ContactInfo.Name),
      Phone:new FormControl(partner.ContactInfo.Phone),
    });
   
    this.showEditPartnerPopUp = true;
    this.partner = partner;
  }

  AddNewPartner(){

    var request = {
      Partner:{
        VAT:this.newPartner.controls['VAT'].value,
        UPN:this.newPartner.controls['UPN'].value,
        Name:this.newPartner.controls['Name'].value,
        COCRegNumber:this.newPartner.controls['COCRegNumber'].value,

        TaxPayer:false,

        BillingAddress:{
          Country:this.newPartner.controls['Country'].value,
          StateProvince:this.newPartner.controls['StateProvince'].value,
          City:this.newPartner.controls['City'].value,
          AddressLine:this.newPartner.controls['AddressLine'].value,
          ZipCode:this.newPartner.controls['ZipCode'].value,
        },
        Bank:this.newPartnerBank,
        ContactInfo:{
          Email:this.newPartner.controls['Email'].value,
          Name:this.newPartner.controls['ContactName'].value,
          Phone:this.newPartner.controls['Phone'].value,
        },
        Company:this.parent.Company
      },
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    if(request.Partner.Bank != null){
      request.Partner.Bank.BankAccount = this.newPartner.controls['BankAccount'].value;
    }

    if(this.newPartner.controls['TaxPayer'].touched != false && this.newPartner.controls['TaxPayer'].value != ''){
      request.Partner.TaxPayer = this.newPartner.controls['TaxPayer'].value;
    }
    else{
      request.Partner.TaxPayer = false;
    }
    
    if(this.newPartner.valid){

      this.parent.loading = true;

      this.service.AddNewPartner(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.initializeAddPartnerForm();
          this.showAddNewPartnerPopUp = false;
          this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
          this.GetPartnerOnAdd(response["ID"]);
        }
     
        this.parent.loading = false;
      });
       };

     if(!this.newPartner.valid){
      this.newPartner.controls['Name'].touched = true;
      this.newPartner.controls['Country'].touched = true;
      this.newPartner.controls['StateProvince'].touched = true;
      this.newPartner.controls['City'].touched = true;
      this.newPartner.controls['AddressLine'].touched = true;
      this.newPartner.controls['ZipCode'].touched = true;
      }

    }

    GetPartnerOnAdd(id:string){

      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        PartnerID:id
      };
  
      this.parent.loading = true;
  
      this.service.GetPartner(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.partner = response["Partner"];
          this.resultsLength = 0;
          this.searchTerm='';
          this.AdjustCurrencyOnPartnerSeleciton();
          this.TestDocumentValidity();
        }
     
        this.parent.loading = false;
      });
  }

  GetPartnersFiltered(searchTerm:string, CountryID:number, resetPaging:boolean){
    var request = {
      SearchTerm:searchTerm,
      CountryID:CountryID,
      PageIndex:1,
      PageSize:this.pageSize,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Company:this.parent.Company
    };

    if(this.searchTerm.length >= 3){
      this.parent.loading = true;

      this.service.GetPartnersFiltered(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Partners = response["Partners"];
         this.resultsLength = response["Count"];
        }
     
        this.parent.loading = false;
      });
    }
  }

  UpdatePartner(){
    var request = {
      Partner:{
        ID:String,
        VAT:this.currentPartner.controls['VAT'].value,
        UPN:this.currentPartner.controls['UPN'].value,
        Name:this.currentPartner.controls['Name'].value,
        COCRegNumber:this.currentPartner.controls['COCRegNumber'].value,

        TaxPayer:this.currentPartner.controls['TaxPayer'].value,

        BillingAddress:{
          ID:Number,
          Country:this.currentPartner.controls['Country'].value,
          StateProvince:this.currentPartner.controls['StateProvince'].value,
          City:this.currentPartner.controls['City'].value,
          AddressLine:this.currentPartner.controls['AddressLine'].value,
          ZipCode:this.currentPartner.controls['ZipCode'].value,
        },
        Bank:this.currentPartner.controls['Bank'].value,
        ContactInfo:{
          ID:Number,
          Email:this.currentPartner.controls['Email'].value,
          Name:this.currentPartner.controls['ContactName'].value,
          Phone:this.currentPartner.controls['Phone'].value,
        },
        Company:this.parent.Company,
        EUVATVerified:this.partner.EUVATVerified,
      },
      User:this.parent.User,
      Language:this.parent.getLanguage()
    };

    request.Partner.Bank.BankAccount = this.currentPartner.controls['BankAccount'].value;
    request.Partner.ID = this.partner.ID;
    request.Partner.BillingAddress.ID = this.partner.BillingAddress.ID;
    request.Partner.ContactInfo.ID = this.partner.ContactInfo.ID;

    this.parent.loading = true;

    this.service.UpdatePartner(request).subscribe(response => {
   
      if(response["Status"] != 1){
      
      }
      else if(response["Status"] == 1){
       this.showEditPartnerPopUp = false;
       this.parent.openSnackBar("Partner Updated", "OK", "light-info-snackbar");
       this.partner = response["Partner"];
      }
   
      this.parent.loading = false;
    });
  }

  public query(searchText: string) {
    this.GetPartnersFiltered(searchText, this.countryID, true);
  }

  GetPurchaseContractsMasterData(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    var x = this.DocumentDate

    this.parent.loading = true;

    this.service.GetPurchaseContractsMasterData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Currencies = response["Currencies"];
        this.DocTypes = response["DocTypes"];
        this.DecimalPrecisions = response["DecimalPrecisions"];
        this.AccountingSeries = response["AccountingSeries"];

        if(this.AccountingSeries == null || this.AccountingSeries.length == 0){
          if(this.purchasecontractURLID == undefined || this.purchasecontractURLID == null){
            this.OpenAccountingSeriesError();
          }
        }

        this.Administrations = response["Administrations"];
        this.MeasuringUnits = response["MeasuringUnits"];
        this.VATRates = response["VATRates"];
        this.currency = this.Currencies[0];
        this.PurchaseContractPrecision = this.DecimalPrecisions[0];
        this.ProductGeneralTypes = response["ProductGeneralTypes"];
        this.DiscountTypes = response["DiscountTypes"];
        this.TaxDivisionTypes = response["TaxDivisionTypes"];
        
        this.PurchaseContractsMasterData = response;
        this.NewProductPriceContainsVAT = false;
      }
   
      this.InitializeNewPurchaseContract();
      this.InitializeNewProduct();
      this.parent.loading = false;
    });

  }

  OpenAccountingSeriesError(){
    this.showAccountingSeriesError = true;
  }

  InsertPartnerFromCloud(partner:any){

    var request = {
      Partner:partner,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.parent.loading = true;

    this.service.AddNewPartner(request).subscribe(response => {
   
      if(response["Status"] != 1){
      
      }
      else if(response["Status"] == 1){
        this.partner.ID = response["ID"];
        this.partner.EUVATVerified = response["EUVATVerified"];
        this.parent.openSnackBar("New Partner Added", "OK", "light-info-snackbar");
      }
   
      this.parent.loading = false;
    });
  }

  ValidateVATNumberEU(partner:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      VAT:partner.value.VAT,
      CountryCode:partner.value.Country.ShortName
    };

    this.parent.loading = true;

    this.service.ValidateVATNumberEU(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
   
      this.parent.loading = false;
    });
  }

  GetPartnerEUData(partner:any, addnew:boolean){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      VAT:partner.value.VAT,
      CountryCode:partner.value.Country.ShortName
    };

    this.parent.loading = true;

    this.service.GetPartnerEUData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1 && response["EUVATVerified"] == true){

        if(addnew){

          this.newPartner = new FormGroup({

            VAT:new FormControl(response["VAT"]),
            UPN:new FormControl(''),
            Name:new FormControl(response["Name"], [Validators.required]),
            COCRegNumber:new FormControl(''),
        
            TaxPayer:new FormControl(response["EUVATVerified"]),
        
            Country:new FormControl(response["Country"]),
            StateProvince:new FormControl(''),
            City:new FormControl(''),
            AddressLine:new FormControl(response["Address"], [Validators.required]),
            ZipCode:new FormControl(''),

            Bank:new FormControl(''),
            BankAccount:new FormControl(''),
        
            Email: new FormControl('', [Validators.email]),
            ContactName:new FormControl(''),
            Phone:new FormControl(''),
          });
        }
        else{

          this.currentPartner = new FormGroup({

            VAT:new FormControl(response["VAT"]),
            UPN:new FormControl(this.partner.UPN),
            Name:new FormControl(response["Name"], [Validators.required]),
            COCRegNumber:new FormControl(this.partner.COCRegNumber),
        
            TaxPayer:new FormControl(response["EUVATVerified"]),
        
            Country:new FormControl(response["Country"]),
            StateProvince:new FormControl(this.partner.BillingAddress.StateProvince, [Validators.required]),
            City:new FormControl(this.partner.BillingAddress.City, [Validators.required]),
            AddressLine:new FormControl(response["Address"], [Validators.required]),
            ZipCode:new FormControl(this.partner.BillingAddress.ZipCode),
        
            Bank:new FormControl(this.partner.Bank),
            BankAccount:new FormControl(this.partner.Bank.BankAccount),
        
            Email: new FormControl(this.partner.ContactInfo.Email, [Validators.email]),
            ContactName:new FormControl(this.partner.ContactInfo.Name),
            Phone:new FormControl(this.partner.ContactInfo.Phone),
          });

          this.partner.EUVATVerified = response["EUVATVerified"];
        }
      }
   
      this.parent.loading = false;
    });
  }

  GetCurrencyLiveExchange(currency:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Currency:currency
    };

    this.parent.loading = true;

    this.service.GetCurrencyLiveExchange(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.currency = response["Currency"];
        this.GetRemainingUIPCValueFromTotal();
      }
   
      this.parent.loading = false;
    });
  }

  AddProductToPurchaseContract(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Price:this.NewProduct.ProductPurchaseContractInfo.Price,
      Precision:this.PurchaseContractPrecision.ID,
      HasVAT:this.NewProductPriceContainsVAT,
      Quantity:this.NewProduct.ProductPurchaseContractInfo.Quantity,
      DocQuantity:this.NewProduct.ProductPurchaseContractInfo.DocQuantity,
      IsStorno:this.IsStorno
    };
  
    this.parent.loading = true;

    this.service.GetPriceInformation(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){

          var aux = JSON.parse(JSON.stringify(this.NewProduct));

          aux.ProductPurchaseContractInfo.Price = response["Price"];

          aux.ProductPurchaseContractInfo.Price.Currency = this.currency;
          aux.ProductPurchaseContractInfo.DecimalPrecision = this.PurchaseContractPrecision;
          aux.ProductPurchaseContractInfo.PriceContainsVAT = this.NewProductPriceContainsVAT;
          aux.ProductPurchaseContractInfo.GeneralType = this.NewProduct.GeneralType;
          aux.ProductPurchaseContractInfo.Quantity = response["Quantity"];
          aux.ProductPurchaseContractInfo.DocQuantity = response["DocQuantity"];
         
          aux.ProductPurchaseContractInfo.UIID = this.parent.newGuid();
          this.Products.push(aux);
          this.TestDocumentValidity();
      }
   
      this.GetPurchaseContractTotalValues();
      this.InitializeNewProduct();
      this.parent.loading = false;
    });

  }

  GetPurchaseContractTotalValues(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Products:JSON.parse(JSON.stringify(this.Products)),
      Precision:this.PurchaseContractPrecision.ID,
      IsStorno:this.IsStorno
    };

    this.parent.loading = true;

    this.service.GetPurchaseContractTotalValues(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){

        this.CurrentPurchaseContract.Total.TotalQtyPriceNOVAT = response["Total"].TotalQtyPriceNOVAT;
        this.CurrentPurchaseContract.Total.TotalVAT = response["Total"].TotalVAT;
        this.CurrentPurchaseContract.Total.TotalQtyPriceVAT = response["Total"].TotalQtyPriceVAT;
        this.GetRemainingUIPCValueFromTotal();
      }
   
      this.parent.loading = false;
    });

  }

  GetSingleExchange(price:any, exchangeRate:any, targetMainCurrency:boolean, precision:any): any{

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Price:price,
      ExchangeRate:exchangeRate,
      IsTargetMainCurrency:targetMainCurrency,
      Precision:precision
    };

    this.loadingEditProduct = true;

    this.service.GetSingleExchange(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        return response["Price"];
      }
   
      this.loadingEditProduct = false;
    });

    return null;
  }

  DeleteAuxProduct(id:string){

    this.Products = this.Products.filter(item => item.ProductPurchaseContractInfo.UIID != id);
    this.GetPurchaseContractTotalValues();
  }

  chanveNewProductVALUE(event){
    
    this.IsValidNewProduct = false;

    if(this.NewProduct.ProductPurchaseContractInfo.Administration != null){
      if(this.NewProduct.ProductPurchaseContractInfo.MeasuringUnit != null){
        if(this.NewProduct.ProductPurchaseContractInfo.Price.VAT != null){
          if(this.PurchaseContractPrecision != null){
            if(this.NewProduct.ProductPurchaseContractInfo.Name != null && this.NewProduct.ProductPurchaseContractInfo.Name.length > 0){
              if(this.NewProduct.ProductPurchaseContractInfo.Code != null && this.NewProduct.ProductPurchaseContractInfo.Code.length > 0){
                if(this.NewProduct.ProductPurchaseContractInfo.Price != null){
                  if((this.NewProduct.ProductPurchaseContractInfo.Price.UIVATUnitPrice != null && this.NewProduct.ProductPurchaseContractInfo.Price.UIVATUnitPrice.toString().length > 0 && this.NewProductPriceContainsVAT) || (this.NewProduct.ProductPurchaseContractInfo.Price.UIUnitPrice != null && this.NewProduct.ProductPurchaseContractInfo.Price.UIUnitPrice.toString().length > 0 && !this.NewProductPriceContainsVAT)){
                    if(this.NewProduct.ProductPurchaseContractInfo.Quantity > 0 && this.NewProduct.ProductPurchaseContractInfo.DocQuantity > 0 && this.NewProduct.ProductPurchaseContractInfo.Code.length > 0 && this.NewProduct.ProductPurchaseContractInfo.Name.length > 0){
                      this.IsValidNewProduct = true;
                    }
                  }
                }
              }
           }
          }
        }
      }
    }
  }

  AdjustProductsDecimalPrecisionPrice(){

      setTimeout(()=>{                         
        if(this.Products != undefined && this.Products != null && this.Products.length > 0){
          this.Products.forEach(p => {
            this.CurrentProduct = JSON.parse(JSON.stringify(p));
            this.CurrentProduct.ProductPurchaseContractInfo.DecimalPrecision = this.PurchaseContractPrecision;

            var request = {
              User:this.parent.User,
              Language:this.parent.getLanguage(),
              Price:this.CurrentProduct.ProductPurchaseContractInfo.Price,
              Precision:this.PurchaseContractPrecision.ID,
              HasVAT:this.CurrentProduct.ProductPurchaseContractInfo.PriceContainsVAT,
              Quantity:this.CurrentProduct.ProductPurchaseContractInfo.Quantity,
              DocQuantity:this.CurrentProduct.ProductPurchaseContractInfo.DocQuantity,
              IsStorno:this.IsStorno,
              Discount:null
            };
        
            if(this.CurrentProduct.ProductPurchaseContractInfo.Price.Discount != undefined){
              request.Discount = this.CurrentProduct.ProductPurchaseContractInfo.Price.Discount;
            }
        
            this.service.GetPriceInformation(request).subscribe(response => {
           
              if(response["Status"] != 1){
                this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
              }
              else if(response["Status"] == 1){
                 
                  this.CurrentProduct.ProductPurchaseContractInfo.Quantity = response["Quantity"];
                  this.CurrentProduct.ProductPurchaseContractInfo.DocQuantity = response["DocQuantity"];
                  this.CurrentProduct.ProductPurchaseContractInfo.Price = response["Price"];
                  p.ProductPurchaseContractInfo.Price = this.CurrentProduct.ProductPurchaseContractInfo.Price;
                  p.ProductPurchaseContractInfo.DecimalPrecision = this.PurchaseContractPrecision;
                  this.GetPurchaseContractTotalValues();
              }
            });
          });
        }
      }, 0);
  }

  ShowPurchaseContractEditProductContainer:boolean;
  ReserveProduct:any;

  OpenPurchaseContractEditProduct(id:string){

    this.Products.forEach(p => {
      if(p.ProductPurchaseContractInfo.UIID == id){
        this.CurrentProduct = JSON.parse(JSON.stringify(p));
        this.ReserveProduct = JSON.parse(JSON.stringify(this.CurrentProduct));
        this.ShowPurchaseContractEditProductContainer = true;
      }
    });
  }

  RevertProduct(){
    this.CurrentProduct = this.ReserveProduct;

    for (let i = 0; i < this.Products.length ; i++) {
      if(this.Products[i].ProductPurchaseContractInfo.UIID == this.CurrentProduct.ProductPurchaseContractInfo.UIID){
        this.Products[i] = JSON.parse(JSON.stringify(this.CurrentProduct));
      }
    }
    
  }

  ModifyPurchaseContractProduct(maintainOpenPopUp:boolean = false){

  var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Price:this.CurrentProduct.ProductPurchaseContractInfo.Price,
      Precision:this.PurchaseContractPrecision.ID,
      HasVAT:this.CurrentProduct.ProductPurchaseContractInfo.PriceContainsVAT,
      Quantity:this.CurrentProduct.ProductPurchaseContractInfo.Quantity,
      DocQuantity:this.CurrentProduct.ProductPurchaseContractInfo.DocQuantity,
      IsStorno:this.IsStorno,
      Discount:null
    };

    if(this.CurrentProduct.ProductPurchaseContractInfo.Price.Discount != undefined){
      request.Discount = this.CurrentProduct.ProductPurchaseContractInfo.Price.Discount;
    }

    if(maintainOpenPopUp == false){
      this.loadingEditProduct = true;
    }

    this.service.GetPriceInformation(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
         
          this.CurrentProduct.ProductPurchaseContractInfo.Quantity = response["Quantity"];
          this.CurrentProduct.ProductPurchaseContractInfo.DocQuantity = response["DocQuantity"];

          this.CurrentProduct.ProductPurchaseContractInfo.Price = response["Price"];

          if(maintainOpenPopUp == false){
            this.ShowPurchaseContractEditProductContainer = false;
          }

          this.showProductDiscountContainer = false;
          this.Products[this.CurrentIndexProduct] = JSON.parse(JSON.stringify(this.CurrentProduct));
      }
   
      this.GetPurchaseContractTotalValues();
      this.loadingEditProduct = false;
    });
  }

  priceContainsVATchanged($event){

    if($event.checked == true){

      if(this.CurrentProduct != null){
        this.CurrentProduct.ProductPurchaseContractInfo.Price.UIVATUnitPrice = JSON.parse(JSON.stringify(this.CurrentProduct.ProductPurchaseContractInfo.Price.UIUnitPrice));
      }

      if(this.NewProduct != null){
        this.NewProduct.ProductPurchaseContractInfo.Price.UIVATUnitPrice = JSON.parse(JSON.stringify(this.NewProduct.ProductPurchaseContractInfo.Price.UIUnitPrice));
      }
    }
    else{
      if(this.CurrentProduct != null){
        this.CurrentProduct.ProductPurchaseContractInfo.Price.UIUnitPrice = JSON.parse(JSON.stringify(this.CurrentProduct.ProductPurchaseContractInfo.Price.UIVATUnitPrice));
      }

      if(this.NewProduct != null){
        this.NewProduct.ProductPurchaseContractInfo.Price.UIUnitPrice = JSON.parse(JSON.stringify(this.NewProduct.ProductPurchaseContractInfo.Price.UIUnitPrice));
      }
    }

    if(this.CurrentProduct != null){
      this.ModifyPurchaseContractProduct(true);
    }

  }

  AddPurchaseContract(){

    this.CurrentPurchaseContract.Supplier = this.partner;
    this.CurrentPurchaseContract.Currency = this.currency;
    
    if(this.DocumentDate.value._d != undefined){
      this.CurrentPurchaseContract.DocumentDate = moment(this.DocumentDate.value._d).format('YYYY-MM-DD');
    }

    if(this.PaymentDueDate.value._d != undefined){
      this.CurrentPurchaseContract.PaymentDueDate = moment(this.PaymentDueDate.value._d).format('YYYY-MM-DD');
    }

    if(this.StockEntryDate.value._d != undefined){
      this.CurrentPurchaseContract.StockEntryDate = moment(this.StockEntryDate.value._d).format('YYYY-MM-DD');
    }

    this.CurrentPurchaseContract.Currency.DecimalPrecision = this.PurchaseContractPrecision;
    this.CurrentPurchaseContract.Products = this.Products;
    this.CurrentPurchaseContract.IsStorno = this.IsStorno;

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PurchaseContract:this.CurrentPurchaseContract
    };

    this.parent.loading = true;

    this.service.AddPurchaseContract(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentPurchaseContract.ID = response["ID"];
        this.IsStorno = false;
        this.SavedPurchaseContract = true;
        this.VizualizeDocument();
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }

      this.DocumentDate = new FormControl(moment(this.CurrentPurchaseContract.DocumentDate));
      this.PaymentDueDate =  new FormControl(moment(this.CurrentPurchaseContract.PaymentDueDate));
      this.StockEntryDate =  new FormControl(moment(this.CurrentPurchaseContract.StockEntryDate));
      this.parent.loading = false;
    });
  }

  UpdatePurchaseContract(){

    this.CurrentPurchaseContract.Supplier = this.partner;
    this.CurrentPurchaseContract.Currency = this.currency;

    if(this.DocumentDate.value._d != undefined){
      this.CurrentPurchaseContract.DocumentDate = moment(this.DocumentDate.value._d).format('YYYY-MM-DD');
    }

    if(this.PaymentDueDate.value._d != undefined){
      this.CurrentPurchaseContract.PaymentDueDate = moment(this.PaymentDueDate.value._d).format('YYYY-MM-DD');
    }

    if(this.StockEntryDate.value._d != undefined){
      this.CurrentPurchaseContract.StockEntryDate = moment(this.StockEntryDate.value._d).format('YYYY-MM-DD');
    }
    
    this.CurrentPurchaseContract.Currency.DecimalPrecision = this.PurchaseContractPrecision;
    this.CurrentPurchaseContract.Products = this.Products;

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PurchaseContract:this.CurrentPurchaseContract
    };

    this.parent.loading = true;

    this.service.UpdatePurchaseContract(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.SavedPurchaseContract = true;
        this.VizualizeDocument();
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }

      this.DocumentDate = new FormControl(moment(this.CurrentPurchaseContract.DocumentDate));
      this.PaymentDueDate =  new FormControl(moment(this.CurrentPurchaseContract.PaymentDueDate));
      this.StockEntryDate =  new FormControl(moment(this.CurrentPurchaseContract.StockEntryDate));
   
      this.parent.loading = false;
    });
  }

  VizualizeDocument(){
    this.GetPurchaseContract(this.CurrentPurchaseContract.ID, true);
    this.showPurchaseContractVisualizer = true;
  }

  GetProductsFiltered(searchTermProducts:string, administrationID:number, isFromPopUp:boolean){

    var request = {
      SearchTerm:searchTermProducts,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      AdministrationID:administrationID,
      PageIndex:1,
      PageSize:this.pageSize,
      IncludeStock:false
    };

    if(searchTermProducts.length >= 3){
      this.loadingSearchProducts = true;

      this.service.GetProductsFiltered(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){

          if(!isFromPopUp){
            this.ProductsSearchResults = response["Products"];
            this.ProductsSearchResultsCOUNT = response["Count"];
          }
        else{
          this.ProductsSearchResultsPop = response["Products"];
          this.ProductsSearchResultsCOUNTPop = response["Count"];
        }
        }
     
        this.loadingSearchProducts = false;
      });
    }
  }

  SearchProductsPurchaseContractInformation(searchTermProducts:string, administrationID:number, isFromPopUp:boolean){

    var request = {
      SearchTerm:searchTermProducts,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      AdministrationID:administrationID,
      PageIndex:1,
      PageSize:50,
      IncludeStock:false,
      Partner:this.partner,
      GeneralDocType:this.DocTypes[0].ID,
      PurchaseMasterData:this.PurchaseContractsMasterData,
      InitialPaymentsRemainingValue:this.InitialPaymentsRemainingValue,
      NewProductPriceContainsVAT:this.NewProductPriceContainsVAT,
      DecimalPrecision:this.PurchaseContractPrecision,
      SuggestFromPool:true,
    };

     if(searchTermProducts != null && searchTermProducts.length >= 3){
      this.loadingSearchProducts = true;
  
      this.service.SuggestProducts(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){

          if(!isFromPopUp){
            this.ProductsSearchResults = response["Products"];
            this.ProductsSearchResultsCOUNT = response["Count"];
          }
        else{
          this.ProductsSearchResultsPop = response["Products"];
          this.ProductsSearchResultsCOUNTPop = response["Count"];
         }
        }
       
        this.loadingSearchProducts = false;
      });
     }
  }

  DestroySearchedProducts(){
    this.ProductsSearchResultsCOUNT = 0;
      this.ProductsSearchResults = [];

      if(this.NewProduct != undefined){
        if(this.NewProduct.ProductPurchaseContractInfo != null){
          this.NewProduct.ProductPurchaseContractInfo.Name = "";
          this.NewProduct.ProductPurchaseContractInfo.Code = "";
          this.NewProduct.ProductPurchaseContractInfo.ProductID = null;
        }

        this.NewProduct.ID = null;
      }
      
      if(this.CurrentProduct != undefined){
        if(this.CurrentProduct.ProductPurchaseContractInfo != null){
          this.CurrentProduct.ProductPurchaseContractInfo.Name = "";
          this.CurrentProduct.ProductPurchaseContractInfo.Code = "";
          this.CurrentProduct.ProductPurchaseContractInfo.ProductID = null;
        }

          this.CurrentProduct.ID = null;
      }
  
      this.IsValidNewProduct = false;
      this.ProductsSearchResultsCOUNTPop = 0;
      this.ProductsSearchResultsPop = [];
  }

  SelectPurchaseContractProductFromSearch(product:any){

    if(product.ProductPurchaseContractInfo != null){
      this.NewProduct = product;
      this.NewProductPriceContainsVAT = this.NewProduct.ProductPurchaseContractInfo.PriceContainsVAT;
    }
    else{
      this.NewProduct = {
        ID:null,
        GeneralType:product.GeneralType,
        ProductPurchaseContractInfo:{
          Administration:product.Administration,
          Name:product.Name,
          Code:product.Code,
          MeasuringUnit:this.MeasuringUnits[0],
          Quantity:1,
          Price:{
            VAT:this.VATRates[0]
          },
          Total:null,
          TotalVATValue:null,
        },
      };
    }

    this.GetMostRecentProductInformation(this.NewProduct);
    this.ProductsSearchResultsCOUNT = 0;
    this.ProductsSearchResults = [];
  }

  GetMostRecentProductInformation(p:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      GeneralDocType:this.parent.masterData.GeneralDocTypes[0].ID,
      DecimalPrecision:this.PurchaseContractPrecision,
      Product:p,
      Partner:this.partner,
      PartnerIsClient:false,
    };
   
      this.loadingSearchProducts = true;

      this.service.GetMostRecentProductInformation(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.NewProduct = response["Product"];
          this.IsValidNewProduct = false;
          this.chanveNewProductVALUE(null);
        }
     
        this.loadingSearchProducts = false;
      });
  }

  SelectPurchaseContractProductFromSearchCurrent(product:any){
    
    if(product.ProductPurchaseContractInfo != null){
      product.ProductPurchaseContractInfo.ProductID = product.ID;
      product.ProductPurchaseContractInfo.DecimalPrecision = this.CurrentProduct.ProductPurchaseContractInfo.DecimalPrecision;
      product.ProductPurchaseContractInfo.Description = this.CurrentProduct.ProductPurchaseContractInfo.Description;
      product.ProductPurchaseContractInfo.DescriptionRows = this.CurrentProduct.ProductPurchaseContractInfo.DescriptionRows;
      product.ProductPurchaseContractInfo.DocQuantity = this.CurrentProduct.ProductPurchaseContractInfo.DocQuantity;
      product.ProductPurchaseContractInfo.Quantity = this.CurrentProduct.ProductPurchaseContractInfo.Quantity;
      product.ProductPurchaseContractInfo.Price = this.CurrentProduct.ProductPurchaseContractInfo.Price;
      product.ProductPurchaseContractInfo.PriceContainsVAT = this.CurrentProduct.ProductPurchaseContractInfo.PriceContainsVAT;
      product.ProductPurchaseContractInfo.Total = this.CurrentProduct.ProductPurchaseContractInfo.Total;
      product.ProductPurchaseContractInfo.TotalVATValue = this.CurrentProduct.ProductPurchaseContractInfo.TotalVATValue;
      product.ProductPurchaseContractInfo.VAT = this.CurrentProduct.ProductPurchaseContractInfo.VAT;

      this.CurrentProduct = product;
      this.NewProductPriceContainsVAT = this.CurrentProduct.ProductPurchaseContractInfo.PriceContainsVAT;
    }
    else{
      this.NewProduct = {
        ID:null,
        GeneralType:product.GeneralType,
        ProductPurchaseContractInfo:{
          Administration:product.Administration,
          Name:product.Name,
          Code:product.Code,
          MeasuringUnit:this.MeasuringUnits[0],
          Quantity:1,
          Price:{
            VAT:this.VATRates[0]
          },
          Total:null,
          TotalVATValue:null,
        },
      };
    }

    this.GetMostRecentProductInformation(this.NewProduct);
    this.ProductsSearchResultsCOUNT = 0;
    this.ProductsSearchResults = [];
  }

  showProductDiscountContainer:boolean;
  showDocumentDiscountContainer:boolean;

  OpenProductDiscountContainer(p:any){

    if(p != null){
      this.CurrentProduct = JSON.parse(JSON.stringify(p));
      this.showProductDiscountContainer = true;
    }
  }

  OpenDocumentDiscountContainer(){
    this.showDocumentDiscountContainer = true;
  }

  ApplyDiscount(){

    this.Products.forEach(p => {
      if(p.ProductPurchaseContractInfo.UIID == this.CurrentProduct.ProductPurchaseContractInfo.UIID){
        p.ProductPurchaseContractInfo = this.CurrentProduct.ProductPurchaseContractInfo;
        this.ModifyPurchaseContractProduct();
      }
    });
    
  }

  RadioChangeDiscountType($event: MatRadioChange){
    
  }

  ApplyPurchaseContractDiscount(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PurchaseContract:JSON.parse(JSON.stringify(this.CurrentPurchaseContract))
    };

    request.PurchaseContract.Products = JSON.parse(JSON.stringify(this.Products));

    this.parent.loading = true;

    this.service.ApplyPurchaseContractDiscount(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentPurchaseContract = response["PurchaseContract"];
        this.Products = response["PurchaseContract"].Products;
      }
   
      this.showDocumentDiscountContainer = false;
      this.parent.loading = false;
    });
  }

  EliminateProductDiscount(){
    this.CurrentProduct.ProductPurchaseContractInfo.Price.Discount = {
      Type:null,
      Value:null
    };

    this.ModifyPurchaseContractProduct();
  }

  EliminateDocumentDiscount(){
    this.CurrentPurchaseContract.Total.Discount = {
      Type:null,
      Value:null
    };

    this.ApplyPurchaseContractDiscount();
  }

  printPage(name:string, html:string, ID:string) {
    var winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
    'resizable,screenX=50,screenY=50,width=850,height=1050';

var htmlPop = '<embed width=100% height=100%'
    + ' type="application/pdf"'
    + ' src="data:application/pdf;base64,'
    + escape(html)
    + '"></embed>';

var newWindow = window.open("", 'PDF_' + name +"_"+ ID);
newWindow.document.write(htmlPop);
};

   download(filename, text) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(text));
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
}

  ExportPurchaseContract(r:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PurchaseContractID:r.ID,
    };

    this.DocumentBodyLoading = true;

    this.service.ExportPurchaseContract(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.download(Document.Name, Document.PDFStream);
      }

      this.DocumentBodyLoading = false;
    });
  }

  PrintPurchaseContract(r:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PurchaseContractID:r.ID,
    };

    this.DocumentBodyLoading = true;

    this.service.ExportPurchaseContract(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.printPage(Document.Name , Document.PDFStream, Document.ID);
      }

      this.DocumentBodyLoading = false;
    });
  }

  ShowProductTaxDivisionContainer:boolean;
  IsLoadingTaxDivision:boolean;

  GetTaxDivisionCalculation(currentProductID:string){

    var products = [];
    var taxProducts = [];

    this.Products.forEach(p => {
      if(p.ProductPurchaseContractInfo.GeneralType.ID == 1){
        products.push(p);
      }
      else {
        if(p.ProductPurchaseContractInfo.UIID != currentProductID){
          taxProducts.push(p);
        }
      }
    });

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Products:products,
      TaxProduct:this.CurrentProduct
    };

    this.IsLoadingTaxDivision = true;

    this.service.GetTaxDivisionCalculation(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Products = response["Products"];
        
        taxProducts.forEach(p => {
          this.Products.push(p);
        });
      }

      this.IsLoadingTaxDivision = false;
    });
  }

  OpenProductTaxDivision(id:string){

    this.Products.forEach(p => {
      if(p.ProductPurchaseContractInfo.UIID == id){
        this.CurrentProduct = p;

        if(this.CurrentProduct.ProductPurchaseContractInfo.GeneralType.TaxDivisionType == null || this.CurrentProduct.ProductPurchaseContractInfo.GeneralType.TaxDivisionType == undefined){
          this.CurrentProduct.ProductPurchaseContractInfo.GeneralType.TaxDivisionType = {};
          this.CurrentProduct.ProductPurchaseContractInfo.GeneralType.TaxDivisionType.ID = 1;
        }

        this.ShowProductTaxDivisionContainer = true;
        this.GetTaxDivisionCalculation(id);
      }
    });
  }

  RadioChangeTaxDivisionType($event: MatRadioChange){
    this.CurrentProduct.ProductPurchaseContractInfo.GeneralType.TaxDivisionType = $event.value;
    this.GetTaxDivisionCalculation(this.CurrentProduct.ProductPurchaseContractInfo.UIID);
  }

  SubmitTaxProductDistribution(){

    this.Products.forEach(p => {
      if(p.ProductPurchaseContractInfo.UIID == this.CurrentProduct.ProductPurchaseContractInfo.UIID){
        
        p.ProductPurchaseContractInfo.GeneralType.IsTaxConsumed = true;
        this.ShowProductTaxDivisionContainer = false;
      }
    });
  }

  CancelTaxProductDistribution(){
    
    this.Products.forEach(p => {
      if(p.ProductPurchaseContractInfo.UIID == this.CurrentProduct.ProductPurchaseContractInfo.UIID){
        
        p.ProductPurchaseContractInfo.GeneralType.IsTaxConsumed = false;
        this.CurrentProduct.ProductPurchaseContractInfo.GeneralType.IsTaxConsumed = false;
        this.ShowProductTaxDivisionContainer = false;
      }
    });
  }

  DupplicateDocumentPurchaseContracts:any[];

  GetDocumentDupplication(Partner:any, DocumentNumber:string){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:JSON.parse(JSON.stringify(Partner.ID)),
      DocumentNumber:DocumentNumber,
    };

    this.service.GetDocumentDupplication(request).subscribe(response => {
   
      if(response["Status"] == 1){
        this.DupplicateDocumentPurchaseContracts = response["PurchaseContracts"];
      }
   
    });
  }

  AdjustCurrencyOnPartnerSeleciton(){
    this.GetCurrencyLiveExchange(this.partner.BillingAddress.Country.Currency);
  }

  AddPurchaseContractWithReception(){

    this.CurrentPurchaseContract.Supplier = this.partner;
    this.CurrentPurchaseContract.Currency = this.currency;
    
    if(this.DocumentDate.value._d != undefined){
      this.CurrentPurchaseContract.DocumentDate = moment(this.DocumentDate.value._d).format('YYYY-MM-DD');
    }

    if(this.PaymentDueDate.value._d != undefined){
      this.CurrentPurchaseContract.PaymentDueDate = moment(this.PaymentDueDate.value._d).format('YYYY-MM-DD');
    }

    if(this.StockEntryDate.value._d != undefined){
      this.CurrentPurchaseContract.StockEntryDate = moment(this.StockEntryDate.value._d).format('YYYY-MM-DD');
    }

    this.CurrentPurchaseContract.Currency.DecimalPrecision = this.PurchaseContractPrecision;
    this.CurrentPurchaseContract.Products = this.Products;
    this.CurrentPurchaseContract.IsStorno = this.IsStorno;

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PurchaseContract:this.CurrentPurchaseContract,
      InitialPayments:this.InitialPayments
    };

    this.parent.loading = true;

    this.service.AddPurchaseContractWithReception(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentPurchaseContract.ID = response["ID"];
        this.IsStorno = false;
        this.SavedPurchaseContract = true;
        this.VizualizeDocument();
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }

      this.DocumentDate = new FormControl(moment(this.CurrentPurchaseContract.DocumentDate));
      this.PaymentDueDate =  new FormControl(moment(this.CurrentPurchaseContract.PaymentDueDate));
      this.StockEntryDate =  new FormControl(moment(this.CurrentPurchaseContract.StockEntryDate));
      this.parent.loading = false;
    });
  }

  ValidDocument:boolean;

  TestDocumentValidity(){

    this.ValidDocument = true;

    if(this.Products == null || this.Products.length == 0){
      this.ValidDocument = false;
    }

    if(this.DocumentDate.valid == false || this.PaymentDueDate.valid == false || this.StockEntryDate.valid == false){
      this.ValidDocument = false;
    }

    if(this.partner == null){
      this.ValidDocument = false;
    }
  }

  selectedFile: File = null;

  onSelectFile(fileInput: any) {
    this.selectedFile = <File>fileInput.target.files[0];
  }

  UploadPurchaseContractFile(){
    
    const request = new FormData();
    request.append('User.Id', JSON.stringify(this.parent.User.Id));
    request.append('Language', this.parent.getLanguage());
    request.append('PurchaseContractID', this.CurrentPurchaseContract.ID);
    request.append('UploadedFile', this.selectedFile);
    request.append('CompanyID', this.parent.Company.ID);
  
    this.parent.loading = true;
  
    this.service.UploadPurchaseContractFile(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        this.CurrentPurchaseContract.FilePath = response["FilePath"];
        this.selectedFile = null;
      }
     
      this.parent.loading = false;
    });
  }

  DownloadFile(r:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PurchaseContractID:r.ID,
    };
  
    this.parent.loading = true;
  
    this.service.DownloadPurchaseContractFile(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.download(Document.Name, Document.PDFStream);
      }
  
      this.parent.loading = false;
    });
  }

  DeleteFileQuestion:boolean = false;

  OpenDeleteFileQuestion(){
    this.DeleteFileQuestion = true;
  }

  DeleteFile(ID:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PurchaseContractID:ID,
    };
  
    this.parent.loading = true;
  
    this.service.RemovePurchaseContractFile(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.CurrentPurchaseContract.FilePath = null;
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
  
      this.parent.loading = false;
    });
  }

  AutoPrintDocument(i:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PurchaseContractID:i.ID,
    };
  
    this.DocumentBodyLoading = true;
  
    this.service.ExportPurchaseContract(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.parent.AutoPrintDocument(Document);
      }
  
      this.DocumentBodyLoading = false;
    });
  }

  InitializePartnersOnClick(searchTerm:string, CountryID:number, resetPaging:boolean){
    var request = {
      SearchTerm:searchTerm,
      CountryID:CountryID,
      PageIndex:1,
      PageSize:10,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Company:this.parent.Company
    };

    if((this.searchTerm.length >= 3) && (this.Partners == null || this.Partners.length == 0)){
      this.parent.loading = true;

      this.service.GetPartnersFiltered(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
         this.Partners = response["Partners"];
         this.resultsLength = response["Count"];
        }
     
        this.parent.loading = false;
      });
    }
    else{
      this.Partners = [];
      this.resultsLength = 0;
    }
  }

  VerifyPriceModel(p:string){
    var result = this.parent.NormalizePrice(p);
  
    if(this.CurrentProduct != null){
      if(!this.CurrentProduct.ProductPurchaseContractInfo.PriceContainsVAT){
        this.CurrentProduct.ProductPurchaseContractInfo.Price.UIUnitPrice = result;
      }
      else{
        this.CurrentProduct.ProductPurchaseContractInfo.Price.UIVATUnitPrice = result;
      }
    }
  
    if(this.NewProduct != null){
      if(!this.NewProductPriceContainsVAT){
        this.NewProduct.ProductPurchaseContractInfo.Price.UIUnitPrice = result;
      }
      else{
        this.NewProduct.ProductPurchaseContractInfo.Price.UIVATUnitPrice = result;
      }
    }
  }
}
